/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeIncidentDto } from '../models/type-incident-dto';


/**
 * Fonctions de gestion des types d'incidents
 */
@Injectable({
  providedIn: 'root',
})
export class TypesIncidentsService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeIncidentGetList
   */
  static readonly TypeIncidentGetListPath = '/api/types-incidents/list';

  /**
   * Renvoie la liste des types d'incidents.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeIncidentGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeIncidentGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeIncidentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesIncidentsService.TypeIncidentGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeIncidentDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'incidents.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeIncidentGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeIncidentGetList(params?: {
  }): Observable<Array<TypeIncidentDto>> {

    return this.typeIncidentGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeIncidentDto>>) => r.body as Array<TypeIncidentDto>)
    );
  }

  /**
   * Path part for operation typeIncidentLoadList
   */
  static readonly TypeIncidentLoadListPath = '/api/types-incidents/load-list';

  /**
   * Renvoie la liste des types d'incidents (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeIncidentLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeIncidentLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesIncidentsService.TypeIncidentLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'incidents (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeIncidentLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeIncidentLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeIncidentLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeIncidentGet
   */
  static readonly TypeIncidentGetPath = '/api/types-incidents/{id}';

  /**
   * Renvoie le type d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeIncidentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeIncidentGet$Response(params: {

    /**
     * Identifiant du type d&#x27;incident
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeIncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesIncidentsService.TypeIncidentGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeIncidentDto>;
      })
    );
  }

  /**
   * Renvoie le type d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeIncidentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeIncidentGet(params: {

    /**
     * Identifiant du type d&#x27;incident
     */
    id: number;
  }): Observable<TypeIncidentDto> {

    return this.typeIncidentGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeIncidentDto>) => r.body as TypeIncidentDto)
    );
  }

  /**
   * Path part for operation typeIncidentPut
   */
  static readonly TypeIncidentPutPath = '/api/types-incidents/{id}';

  /**
   * Met à jour le type d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeIncidentPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeIncidentPut$Response(params: {

    /**
     * Identifiant du type d&#x27;incident à mettre à jour
     */
    id: number;

    /**
     * Type d'incident
     */
    body: TypeIncidentDto
  }): Observable<StrictHttpResponse<TypeIncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesIncidentsService.TypeIncidentPutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeIncidentDto>;
      })
    );
  }

  /**
   * Met à jour le type d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeIncidentPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeIncidentPut(params: {

    /**
     * Identifiant du type d&#x27;incident à mettre à jour
     */
    id: number;

    /**
     * Type d'incident
     */
    body: TypeIncidentDto
  }): Observable<TypeIncidentDto> {

    return this.typeIncidentPut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeIncidentDto>) => r.body as TypeIncidentDto)
    );
  }

  /**
   * Path part for operation typeIncidentDelete
   */
  static readonly TypeIncidentDeletePath = '/api/types-incidents/{id}';

  /**
   * Supprime le type d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeIncidentDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeIncidentDelete$Response(params: {

    /**
     * Identifiant du type d&#x27;incident à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesIncidentsService.TypeIncidentDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeIncidentDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeIncidentDelete(params: {

    /**
     * Identifiant du type d&#x27;incident à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeIncidentDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeIncidentPost
   */
  static readonly TypeIncidentPostPath = '/api/types-incidents';

  /**
   * Crée le type d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeIncidentPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeIncidentPost$Response(params: {

    /**
     * Type d'incident
     */
    body: TypeIncidentDto
  }): Observable<StrictHttpResponse<TypeIncidentDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesIncidentsService.TypeIncidentPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeIncidentDto>;
      })
    );
  }

  /**
   * Crée le type d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeIncidentPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeIncidentPost(params: {

    /**
     * Type d'incident
     */
    body: TypeIncidentDto
  }): Observable<TypeIncidentDto> {

    return this.typeIncidentPost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeIncidentDto>) => r.body as TypeIncidentDto)
    );
  }

  /**
   * Path part for operation typeIncidentDesactivate
   */
  static readonly TypeIncidentDesactivatePath = '/api/types-incidents/{id}/desactivate';

  /**
   * Désactive le type d'incident spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeIncidentDesactivate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeIncidentDesactivate$Response(params: {

    /**
     * Identifiant du type d&#x27;incident à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeIncidentDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesIncidentsService.TypeIncidentDesactivatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Désactive le type d'incident spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeIncidentDesactivate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeIncidentDesactivate(params: {

    /**
     * Identifiant du type d&#x27;incident à désactiver
     */
    id: number;

    /**
     * Paramètres de désactivation
     */
    body: TypeIncidentDto
  }): Observable<number> {

    return this.typeIncidentDesactivate$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeIncidentGetListActifs
   */
  static readonly TypeIncidentGetListActifsPath = '/api/types-incidents/list-actifs';

  /**
   * Renvoie la liste des types d'incidents actifs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeIncidentGetListActifs()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeIncidentGetListActifs$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeIncidentDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesIncidentsService.TypeIncidentGetListActifsPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeIncidentDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'incidents actifs.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeIncidentGetListActifs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeIncidentGetListActifs(params?: {
  }): Observable<Array<TypeIncidentDto>> {

    return this.typeIncidentGetListActifs$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeIncidentDto>>) => r.body as Array<TypeIncidentDto>)
    );
  }

}
